export { ContactPage } from './ContactPage'
export { AboutPage } from './AboutPage'
export { BlogPage } from './BlogPage'
export { DocsPage } from './DocsPage'
export { PrivacyPage } from './PrivacyPage'
export { TermsPage } from './TermsPage'
